// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 3H16.5V1H7.5V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 6V4H2V6H4.02898L4.52898 23H19.471L19.971 6H22ZM11 19V8H13V19H11Z"}}]};

const DeleteFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'delete-filled',
    ref,
    icon: element,
  },
));

DeleteFilledIcon.displayName = 'DeleteFilledIcon';

export default DeleteFilledIcon;
